import Vue from 'vue'

export default {
  suscribeNewsletter (payload, callback, errorHandler) {
    return Vue.http.post('public/newsletter', payload).then(callback, errorHandler)
  }
}